import React, { useCallback, useEffect, useState } from "react";
import Loading from "../../common/Loading";
import { getUserData, userEditData } from "../../redux/services/studentSlice";
import { useDispatch, useSelector } from "react-redux";
import { BiSearch } from "react-icons/bi";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import NoDataFound from "../../common/NoDataFound";

const StudentPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(0);
  const limit = 10;
  const dispatch = useDispatch();
  const getAllUserData = useSelector((state) => state?.student?.studentData);
  const [loading, setLoading] = useState(false);
  const editUser = async (userId, isblocked) => {
    let payload = {
      userId: userId,
      isBlocked: isblocked,
    };
    try {
      const response = await dispatch(userEditData(payload));
      if (response) {
        getAllUser();
      }
    } catch (error) {}
  };
  const getAllUser = useCallback(async () => {
    try {
      setLoading(true);
      await dispatch(
        getUserData({
          page: page + 1,
          limit,
          searchData,
          filter,
        })
      );
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [dispatch, page, limit, searchData, filter]);

  useEffect(() => {
    if (page || limit || searchData || filter) {
      getAllUser();
    }
  }, [page, limit, searchData, filter, getAllUser]);
  if (loading) return <Loading />;
  const options = [
    { value: "", label: "All" },
    { value: "true", label: "Accept" },
    { value: "false", label: "Block" },
  ];
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "0.375rem",
      borderColor: "#D1D5DB",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#124699",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#124699" : "white",
      color: state.isSelected ? "white" : "#4B5563",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: state.isSelected ? "#124699" : "#e8effa",
        color: state.isSelected ? "white" : "#4B5563",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#4B5563",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#4B5563",
      "&:hover": {
        color: "#124699",
      },
    }),
  };
  return (
    <div className="p-3 border border-slate-300 m-2  overflow-y-auto min-h-full rounded-lg">
      <p className="bg-white p-4">
        Students Details
      </p>
      <div className="flex justify-between items-center py-4 px-5 border-t md:gap-6 gap-2 md:flex-row flex-col">
        <div className="relative max-w-xl w-full">
          <input
            type="text"
            className="max-w-xl w-full px-4 py-2 border rounded-lg focus:outline-none"
            placeholder="Search students..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button
            type="button"
            className="absolute top-0 right-0 px-4 h-full bg-[#124699] text-white rounded-r-lg"
            onClick={() => setSearchData(searchTerm)}
          >
            <BiSearch />
          </button>
        </div>
        <div className="max-w-[300px] w-full">
          <Select
            options={options}
            value={options.find((option) => option.value === filter)}
            onChange={(e) => setFilter(e ? e.value : "")}
            placeholder="Select filter"
            styles={customStyles}
            className="w-full"
            isClearable
          />
        </div>
      </div>
      <div className="relative shadow-md sm:rounded-lg">
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-[#e6eaed]">
              <tr>
                <th className="px-6 py-5 w-[100px]">S/N</th>
                <th className="px-6 py-5 w-[200px]">Name</th>
                <th className="px-6 py-5 w-[250px]">Email</th>
                <th className="px-6 py-5 w-[150px]">Gender</th>
                <th className="px-6 py-5 w-[180px]">Date of Birth</th>
                <th className="px-6 py-5 w-[150px]">City</th>
                <th className="px-6 py-5 w-[150px]">Contact</th>
                <th className="px-6 py-5 w-[150px]">Status</th>
              </tr>
            </thead>
            <tbody>
              {getAllUserData?.subject_data?.length > 0 ? (
                getAllUserData?.subject_data?.map((user, index) => (
                  <tr key={index} className="bg-white border-b !h-[50px]">
                    <td className="px-6 py-6">{page * limit + index + 1}</td>
                    <td className="px-6 py-6">
                      {user.firstName + " " + user.lastName}
                    </td>
                    <td className="px-6 py-6">{user.email}</td>
                    <td className="px-6 py-6">{user.gender}</td>
                    <td className="px-6 py-6">
                      {new Date(user.dob).toLocaleDateString()}
                    </td>
                    <td className="px-6 py-6">{user.city}</td>
                    <td className="px-6 py-6">
                      {user.contact.countryCode + " " + user.contact.mobile}{" "}
                    </td>
                    <td className="p-4 text-center">
                      <button
                        className={`flex items-center justify-center w-[120px] h-8 px-10 select-none rounded-lg text-md align-middle font-sans font-medium text-white transition-all ${
                          user.isBlocked
                            ? "bg-green-500 hover:bg-green-600"
                            : "bg-red-500 hover:bg-red-600"
                        } active:bg-slate-900/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none shadow-md`}
                        type="button"
                        onClick={() => editUser(user._id, !user.isBlocked)}
                      >
                        {user.isBlocked ? "Accept" : "Block"}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <td colSpan={8} className="p-5 text-center text-gray-500">
                  <NoDataFound />
                </td>
              )}
            </tbody>
          </table>
        </div>
        <div className="p-4 ">
          <ReactPaginate
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            pageCount={getAllUserData?.state?.page_limit}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={(data) => setPage(data.selected)}
            containerClassName={"pagination flex justify-center items-center"}
            pageClassName={"page-item py-2 rounded"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item py-2 rounded"}
            nextClassName={"page-item py-2 rounded"}
            activeClassName={"active text-white bg-[#124699]"}
            disabledClassName={
              "disabled bg-gray-100 text-gray-500 cursor-not-allowed"
            }
          />
        </div>
      </div>
    </div>
  );
};

export default StudentPage;
